import { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

export type AlertDismissibleProps = {
  header?: string;
  msgtext: JSX.Element;
  buttontext?: string;
  variant?: string;
  show: boolean;
  setShow: Function;
}

export default function AlertDismissible(props: AlertDismissibleProps) {

  return (
    <Alert show={props.show} className="sticky-top col-xs-12" variant={props.variant} onClose={() => props.setShow(false)} dismissible>
      <Alert.Heading>{props.header}</Alert.Heading>
      <p>
        {props.msgtext}
      </p>
    </Alert>
  );
}

AlertDismissible.defaultProps = {
  header : "Fehler:",
  buttontext: "Verstanden",
  variant: "danger",
}